import { FC } from 'react'
import { Modal } from './Modal'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { PrimaryButton, SecondaryButton } from './Buttons'

interface ModalQuestionProps {
  open: boolean
  title: string
  setAccepts: React.Dispatch<React.SetStateAction<boolean>>
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  classNames?: string
  /** Texto del botón de confirmar. Default "Aceptar". */
  acceptLabel?: string
  /** Texto del botón de cancelar. Default "Cerrar". */
  cancelLabel?: string
}

export const ModalQuestion: FC<ModalQuestionProps> = ({
  open,
  title,
  setOpen,
  setAccepts,
  classNames,
  acceptLabel = 'Aceptar',
  cancelLabel = 'Cerrar',
}) => {
  return (
    <Modal
      open={open}
      setOpen={setOpen}
      /**
       * Antes: `maxWidth: 20rem` con `height: 15rem` FIJO. Cualquier pregunta
       * más larga que una línea se salía de la caja o quedaba apretada contra
       * los botones. Ahora el alto lo pone el contenido y el ancho es un techo,
       * no una medida.
       *
       * `w-full` es obligatorio: el panel del Modal es un flex item con
       * `width: auto`, así que sin esto se encoge al contenido y `maxWidth` no
       * hace nada.
       */
      className={`w-full max-w-[95vw] mx-2 my-1 ${classNames ?? ''}`}
      style={{ maxWidth: '30rem' }}
    >
      <div className="flex flex-col items-center py-2">
        <ExclamationTriangleIcon className="h-14 w-14 shrink-0 text-yellow-400" />

        {/* `whitespace-pre-line` para respetar los \n de los mensajes largos, y
            `break-words` para que un número de carga sin espacios no desborde. */}
        <p className="mt-4 whitespace-pre-line break-words text-center text-base font-semibold text-gray-800">
          {title}
        </p>

        <div className="mt-6 flex flex-row flex-wrap justify-center gap-3">
          <PrimaryButton
            className="px-6"
            onClick={() => {
              setOpen(false)
              setAccepts(true)
            }}
          >
            {acceptLabel}
          </PrimaryButton>
          <SecondaryButton
            className="px-6"
            onClick={() => {
              setOpen(false)
              setAccepts(false)
            }}
          >
            {cancelLabel}
          </SecondaryButton>
        </div>
      </div>
    </Modal>
  )
}
